module.exports = __webpack_public_path__ + "img/px.3ef8bb70.png";